export default __webpack_public_path__ + "98cc870056fbf7dee6a20bb32bc36bea.png";